import { render } from "./PreloaderApp.vue?vue&type=template&id=3a7143ce&scoped=true"
import script from "./PreloaderApp.vue?vue&type=script&lang=js"
export * from "./PreloaderApp.vue?vue&type=script&lang=js"

import "./PreloaderApp.vue?vue&type=style&index=0&id=3a7143ce&scoped=true&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7143ce"]])

export default __exports__